import React, {useState} from 'react'
import * as Yup from 'yup'
import {CSSTransition} from 'react-transition-group'
import {Button, ButtonBack, InputTextFormik} from '../../../../../../../_gori/partials/widgets'
import {useIntl} from 'react-intl'
import UseYupValidate from '../../../../../../../_gori/hooks/UseYupValidate'
import {useFormik} from 'formik'
import useCancelToken from '../../../../../../../_gori/hooks/UseCancelToken'
import SettingsService from '../../../../core/_requests'
import {toast} from 'react-toastify'
import {OrderType} from '../../../../../orders/core/_const'
import {StoresListing} from '../StoresListing'
import {isEmpty} from 'lodash'
import {StorageHelpers} from '../../../../../../../_gori/helpers/StorageHelpers'
import {PromotionBanner, BannerContent} from '../../../../../common/components/PromotionBanner'
import {usePromoEligibility} from '../../../../../../../_gori/hooks/UsePromoEligibility'
import {ConnectionLink} from '../ConnectionLink'
import {KTSVG} from '../../../../../../../_gori/helpers'
import {useNavigate} from 'react-router-dom'
const ConnectWalmart: React.FC = () => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const [isReload, setIsReload] = useState<boolean>(false)
  const {getMarketPromoStatus} = usePromoEligibility()
  const walmartPromoStatus = getMarketPromoStatus('walmart')
  const isPromoEligible = walmartPromoStatus.isEligible
  const isPromoApplied = walmartPromoStatus.isApplied
  const navigate = useNavigate()

  const {walmartYup} = UseYupValidate()
  const validationSchema = Yup.object().shape({
    api_key: walmartYup.apiKey,
    secret_key: walmartYup.secretKey,
  })

  const initialValues = {
    store_type: OrderType.WALMART,
    api_key: '',
    secret_key: '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      const config = {cancelToken: newCancelToken()}
      setStatus('')
      await SettingsService.connect(values, config)
        .then(async () => {
          StorageHelpers.setItemLocalStorage('cardstore', {hidden: true})
          window.dispatchEvent(new Event('storage'))
          toast.success(intl.formatMessage({id: 'CONNECTION_SUCCESSFUL'}))
          handleResetForm()
          setIsReload(true)
        })
        .catch((error) => {
          if (isCancel(error)) return
          let message = error?.response?.data?.error?.message ?? ''
          setStatus(isEmpty(message) ? intl.formatMessage({id: 'INVALID_API_KEY'}) : message)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
  })

  const handleResetForm = () => {
    formik.resetForm()
  }

  const walmartBannerContent: Partial<BannerContent> = {
    helpLinkTo: '/help-center/store-connection/walmart',
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='store-connect-page'>
          <div className='store-connect-page__header'>
            <div className='store-connect-page__header-main'>
              <div className='d-flex align-items-center store-connect-page__back'>
                <ButtonBack className='store-connect-page__back-button me-0' />
                <button
                  type='button'
                  className='store-connect-page__back-arrow'
                  aria-label='Go back'
                  onClick={() => navigate(-1)}
                >
                  <KTSVG path='/media/gori/left_arrow.svg' />
                </button>
              </div>
              <div className='d-flex flex-column'>
                <div className='d-flex gap-4 align-items-center flex-wrap'>
                  <span className='store-connect-page__title fw-bolder text-dark fs-3'>
                    {intl.formatMessage({id: 'CONNECT_TO'})} Walmart
                  </span>
                </div>
                <ConnectionLink url={walmartBannerContent.helpLinkTo || ''} />
              </div>
            </div>
            {isPromoApplied && (
              <PromotionBanner
                isEligible={isPromoEligible}
                isApplied={isPromoApplied}
                content={walmartBannerContent}
              />
            )}
          </div>

          <div className='store-connect-page__body'>
            <div className='store-connect-page__form-card store-connect-page__form-card--stacked'>
              <div className='store-connect-page__form-stack'>
                <div className='row align-items-center store-connect-page__form-stack-row'>
                  <InputTextFormik
                    className='store-connect-page__form-stack-input col-10'
                    labelClassName='store-connect-page__form-stack-label col-2 col-form-label text-nowrap'
                    required
                    label={'Walmart ' + intl.formatMessage({id: 'API_KEY'})}
                    formik={formik}
                    name={'api_key'}
                  />
                </div>
                <div className='row align-items-center store-connect-page__form-stack-row'>
                  <InputTextFormik
                    className='store-connect-page__form-stack-input col-10'
                    labelClassName='store-connect-page__form-stack-label col-2 col-form-label text-nowrap'
                    required
                    label={'Walmart ' + intl.formatMessage({id: 'API_SECRET'})}
                    formik={formik}
                    name={'secret_key'}
                  />
                </div>
                {formik.status && (
                  <div className='col-md-12 mt-5 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>{formik.status}</div>
                  </div>
                )}
                <div className='store-connect-page__form-actions text-end'>
                  <Button
                    className='btn btn-advanced-primary mt-7 store-connect-page__form-stack-connect'
                    label={intl.formatMessage({id: 'CONNECT'})}
                    loadingText={intl.formatMessage({id: 'CONNECT'})}
                    loading={formik.isSubmitting}
                    disabled={formik.isSubmitting || !formik.isValid}
                    event={() => {
                      formik.submitForm()
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='store-connect-page__stores'>
              <StoresListing
                isReload={isReload}
                setIsReload={setIsReload}
                storeType={OrderType.WALMART}
              />
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  )
}

export {ConnectWalmart}
